<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入事件名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入事件名称"
          />
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            type="text"
            :max-length="200"
            rows="3"
            v-decorator="['intro']"
            placeholder="请输入描述,限制200字"
          />
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['imgUrl']"
          />
        </a-form-item>
        <a-form-item
          label="关联主题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'titleId',
              { rules: [{ required: true, message: '请选择关联主题' }] },
            ]"
            placeholder="请选择关联主题"
          >
            <a-select-option
              v-for="(item, index) in titleIds"
              :value="item.id"
              :key="index"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="活动渠道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择活动渠道"
            v-decorator="[
              'channelType',
              { rules: [{ required: true, message: '请选择活动渠道' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_channel_type"
          />
        </a-form-item>
        <a-form-item
          label="是否发奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isAward"
            @change="changeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'prizeSource',
              { rules: [{ required: true, message: '请选择奖品来源' }] },
            ]"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandle"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            id="prizeId"
            v-decorator="[
              'prizeId',
              { rules: [{ required: true, message: '请选择奖品' }] },
            ]"
            placeholder="请选择奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="留言频率限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            :min="1"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="minuMaxNum"
            v-decorator="[
              'minuMaxNum',
              { rules: [{ required: true, message: '请输入留言频率限制' }] },
            ]"
            placeholder="请输入留言频率限制(每分钟可以发表评论的次数)"
          />
        </a-form-item>
        <a-form-item
          label="留言字数限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择留言字数限制"
            v-decorator="[
              'maxLengthLimit',
              { rules: [{ required: true, message: '请选择留言字数限制' }] },
            ]"
            :triggerChange="true"
            dictCode="leave_mess_limit"
          />
        </a-form-item>
        <a-form-item
          label="是否需要审核"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isChecked"
            @change="changeHandler2"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
// import JImageUpload from '@/components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'CommentEventModal',
  components: {
    JDate,
    JMultiSelectTag,
    // JImageUpload,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      titleIds: [], //主题列表
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: 1,
        },
        {
          name: '积分库',
          value: 2,
        },
      ], //奖品来源
      isAward: false, //是否发奖开关，默认关闭状态
      isChecked: false,
      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/leaveMessage/event/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/leaveMessage/event/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.isAward === 1) {
        this.isAward = true;
      } else {
        this.isAward = false;
      }
      if (this.model.isChecked === 1) {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
      this.fileList = record.imgUrl;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          imgUrl: record.imgUrl
            ? process.env.VUE_APP_FILE_PATH + record.imgUrl
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'titleId',
            'name',
            'intro',
            // 'imgUrl',
            'channelType',
            'isAward',
            'prizeSource',
            'prizeId',
            'isChecked',
            'minuMaxNum',
            'maxLengthLimit'
          )
        );
      });

      this.prizeSourceHandle(this.model.prizeSource);
      this.getTitleList();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.isAward = that.isAward === true ? '1' : '0';
          formData.isChecked = that.isChecked === true ? '1' : '0';
          formData.imgUrl = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'titleId',
          'name',
          'intro',
          'imgUrl',
          'channelType',
          'isAward',
          'prizeSource',
          'prizeId',
          'isChecked',
          'minuMaxNum',
          'maxLengthLimit'
        )
      );
    },

    prizeSourceHandle(e) {
      this.form.setFieldsValue({
        //《=关键 清空tag选项
        prizeId: [],
      });
      this.prizesList = [];
      if (e === 1 || e === 2) {
        this.getPrizesList(e);
      }
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === 1) {
        getUrl = this.url.getPrizeList;
      } else if (type === 2) {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === 2) {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
        }
      });
    },

    changeHandler(e) {
      this.isAward = e;
    },
    changeHandler2(e) {
      this.isChecked = e;
    },

    /**获取主题列表*/
    getTitleList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/leave/comment/queryAll';
      getAction(getUrl, {}).then((res) => {
        if (res.success) {
          this.titleIds = res.result;
        }
      });
    },

    receiveTypesValue(e) {},
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        imgUrl: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
